import { ca } from '@cian/analytics';

export interface ITrackAddFavoriteGallery {
  newbuildingId: number;
  url?: string;
}

export function trackAddFavoriteGallery({ newbuildingId, url }: ITrackAddFavoriteGallery) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'add_from_compare_jk',
    label: url,
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      extra: {
        seller_type: 'builders',
      },
      siteType: 'desktop',
      pageType: 'ListingCompareJK',
    },
  });
}
